import React from "react";
import styles from "../../../Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab/EventsShiftsTab.module.scss";
import searchIcon from "assets/images/search-icon.svg";
import closeIcon from "assets/images/close-icon.svg";

export default function ExpandableSearchBar({
  placeholder,
  searchValue = "",
  setSearchValue,
  isFocused,
  setIsFocused,
  expanded = false,
}) {
  const handleClearSearch = () => {
    setSearchValue("");
    setIsFocused && setIsFocused(false);
  };

  return (
    <div
      className={`${styles["search-form"]} ${
        expanded
          ? styles["search-expanded"]
          : isFocused
          ? styles["expanded"]
          : ""
      }`}
    >
      <img
        src={searchIcon}
        alt="Search Icon"
        className={styles["search-icon"]}
      />
      <input
        type="text"
        placeholder={placeholder}
        value={searchValue}
        onFocus={() => setIsFocused && setIsFocused(true)}
        onChange={(e) => setSearchValue(e.target.value)}
        onBlur={() =>
          !searchValue?.trim() && setIsFocused && setIsFocused(false)
        }
        className={`${styles["search-input"]} ${
          isFocused ? styles["expanded"] : ""
        }`}
      />
      {(expanded || isFocused) && searchValue?.trim() && (
        <button
          type="button"
          onClick={handleClearSearch}
          className={styles["clear-button"]}
        >
          <img src={closeIcon} alt="Clear" />
        </button>
      )}
    </div>
  );
}
